var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import styled from 'styled-components';
import { hslRegex } from '../utilities';
import { SAIcon, SAIcons, SAIconSize } from '../icon';
function getRadius(theme, size) {
    switch (size) {
        case 'small':
            return theme === null || theme === void 0 ? void 0 : theme.size.radius.small;
        case 'medium':
            return theme === null || theme === void 0 ? void 0 : theme.size.radius.medium;
        case 'large':
            return theme === null || theme === void 0 ? void 0 : theme.size.radius.large;
        default:
            return '100px';
    }
}
function getFontWeight(theme, weight) {
    var fontWeight = '';
    if (weight === 'normal') {
        fontWeight = theme === null || theme === void 0 ? void 0 : theme.font.primary.weight.normal;
    }
    if (weight === 'bold') {
        fontWeight = theme === null || theme === void 0 ? void 0 : theme.font.primary.weight.bold;
    }
    return fontWeight;
}
// TODO: Figure out why this any type is needed.
var StyledTag = styled.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var _a;
    var fontWeight = props.fontWeight, radius = props.radius, theme = props.theme, variant = props.variant, withBorder = props.withBorder;
    var color = (function setColor() {
        var variantBase = variant.split('-')[0];
        switch (variantBase) {
            case 'alert':
                return theme === null || theme === void 0 ? void 0 : theme.color.alert.background;
            case 'highlight':
                return theme === null || theme === void 0 ? void 0 : theme.color.highlight.background;
            case 'primary':
                return theme === null || theme === void 0 ? void 0 : theme.color.primary.background;
            case 'secondary':
                return theme === null || theme === void 0 ? void 0 : theme.color.secondary.background;
            case 'tertiary':
                return theme === null || theme === void 0 ? void 0 : theme.color.tertiary.background;
            case 'standard':
            default:
                return theme === null || theme === void 0 ? void 0 : theme.colors.text;
        }
    })();
    var _b = (_a = color === null || color === void 0 ? void 0 : color.match(hslRegex)) === null || _a === void 0 ? void 0 : _a.map(function (part) { return Number(part.trim()); }), h = _b[1], s = _b[2], l = _b[3];
    if (!variant.includes('outline')) {
        color = "hsl(" + h + ", " + s + "%, " + l + "%)";
    }
    var border = !variant.includes('outline') ? 'transparent' : color;
    border = withBorder ? color : border;
    var borderRadius = getRadius(theme, radius);
    var background = !variant.includes('outline') ? "hsl(" + h + ", 95%, 95%)" : 'transparent';
    background = !variant.includes('outline') && s === 0 ? "hsl(" + h + ", 0%, 95%)" : background;
    var size = variant.includes('small') ? theme === null || theme === void 0 ? void 0 : theme.font.primary.size.small : theme === null || theme === void 0 ? void 0 : theme.font.primary.size.smallTEMP;
    var height = variant.includes('small') ? '21px' : '29px';
    var weight = variant.includes('small') ? theme === null || theme === void 0 ? void 0 : theme.font.primary.weight.normal : theme === null || theme === void 0 ? void 0 : theme.font.primary.weight.bold;
    weight = theme && fontWeight ? getFontWeight(theme, fontWeight) : weight;
    var padding = variant.includes('small')
        ? (theme === null || theme === void 0 ? void 0 : theme.size.spacer.xxs) + " " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.small) + " calc(" + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.xxs) + " + 1px)"
        : (theme === null || theme === void 0 ? void 0 : theme.size.spacer.xs) + " " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.small) + " calc(" + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.xs) + " + 1px)";
    return "\n      background-color: " + background + ";\n      border: 1px solid " + border + ";\n      border-radius: " + borderRadius + ";\n      color: " + color + ";\n      display: inline-flex;\n      font-size: " + size + ";\n      font-weight: " + weight + ";\n      padding: " + padding + ";\n      white-space: nowrap;\n      align-items: center;\n      box-sizing: border-box;\n      height: " + height + ";\n    ";
});
// TODO: Figure out why this any type is needed.
var CloseIcon = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var theme = props.theme;
    return "\n      vertical-align: middle;\n      padding-left: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.small) + ";\n\n      button {\n        display: flex;\n        align-items: center;\n\n        &:hover {\n          cursor: pointer;\n        }\n\n        &:focus {\n          background: rgba(0, 0, 0, 0.1);\n          border-radius: 25px;\n        }\n      }\n    ";
});
export function SATag(_a) {
    var closeable = _a.closeable, label = _a.label, onClose = _a.onClose, variant = _a.variant, rest = __rest(_a, ["closeable", "label", "onClose", "variant"]);
    var _b = useState(true), visible = _b[0], setVisible = _b[1];
    function handleClose(e, Taglabel) {
        setVisible(false);
        if (onClose) {
            onClose(e, Taglabel);
        }
    }
    function getIconColor() {
        var variantBase = variant.split('-')[0];
        switch (variantBase) {
            case 'alert':
                return 'alert';
            case 'highlight':
                return 'highlight';
            case 'primary':
                return 'primary';
            case 'secondary':
                return 'secondary';
            case 'tertiary':
                return 'tertiary';
            default:
                return 'dark';
        }
    }
    var iconColor = getIconColor();
    var closeIcon = closeable ? (React.createElement(SAIcon, { icon: SAIcons.x, size: variant.includes('small') ? "" + SAIconSize.small : "20px", colorVariant: iconColor, onClick: function (e) { return handleClose(e, label); } })) : ('');
    return (React.createElement(React.Fragment, null, visible && (
    /* eslint-disable react/jsx-props-no-spreading */
    React.createElement(StyledTag, __assign({ variant: variant }, rest),
        label,
        closeable && React.createElement(CloseIcon, null, closeIcon)))));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=tag.component.js.map